import firebase from '@firebase/app'
import '@firebase/database'

const state = {
  contentProgress: [],
  contentProgressRef: null,
  contentProgressLoaded: false
}

const getters = {
  contentProgress (state) {
    return state.contentProgress
  },
  contentProgressRef (state) {
    return state.contentProgressRef
  },
  contentProgressLoaded (state) {
    return state.contentProgressLoaded
  },
  contentProgressByKey (state) {
    return (contentProgressKey) => {
      return state.contentProgress.find(c => {
        return c.key === contentProgressKey
      })
    }
  },
  contentProgressByProgressByUrl (state) {
    return (progressKey, contentProgressUrl) => {
      return state.contentProgress.find(p => {
        return (p.progressKey === progressKey) && (p.url === contentProgressUrl)
      })
    }
  },
  contentProgressByProgressByContent (state) {
    return (progressKey, contentKey) => {
      return state.contentProgress.find(p => {
        return (p.progressKey === progressKey) && (p.contentKey === contentKey)
      })
    }
  }
}

const mutations = {
  setContentProgress (state, payload) {
    state.contentProgress = payload
  },
  setContentProgressRef (state, payload) {
    state.contentProgressRef = payload
  },
  setContentProgressLoaded (state, payload) {
    state.contentProgressLoaded = payload
  }
}

const actions = {
  loadContentProgress: (store, payload) => new Promise((resolve, reject) => {
    const ref = firebase.database().ref('contentProgress').child(payload)
    ref.on('value', snapshot => {
      const contentProgress = []
      snapshot.forEach(p => {
        contentProgress.push({key: p.key, ...p.val()})
      })
      store.commit('setContentProgress', contentProgress)
      store.commit('setContentProgressRef', ref)
      store.commit('setContentProgressLoaded', true)
      resolve()
    })
  }),
  createContentProgress: (store, payload) => new Promise((resolve, reject) => {
    const newContentProgress = {...payload}
    store.getters.contentProgressRef.push(newContentProgress).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  updateContentProgress: (store, payload) => new Promise((resolve, reject) => {
    const newContentProgress = {...payload}
    store.getters.contentProgressRef.child(newContentProgress.key).set(newContentProgress).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  resetContentProgress: (store) => new Promise((resolve, reject) => {
    if (store.getters.contentProgressRef) store.getters.contentProgressRef.off()
    store.commit('setContentProgress', [])
    store.commit('setContentProgressRef', null)
    store.commit('setContentProgressLoaded', false)
    resolve()
  })
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/student/contentProgress.js